import { generatePath, Outlet } from 'react-router';

import { PERMISSIONS } from 'api/auth/constants';
import { ICONS_MAP } from 'constants/icons';
import { ROUTES } from 'routes/config/constants';
import { IRoutesConfigItem } from 'routes/config/index';
import { appLazy } from 'routes/ErrorBoundary/appReloadLazy';

const SettlementContracts = appLazy(
  () => import('routes/pages/AuthorizedStack/Settlement/SettlementContracts'),
);
const SettlementContract = appLazy(
  () =>
    import(
      'routes/pages/AuthorizedStack/Settlement/SettlementContracts/SettlementContract/View'
    ),
);
const CreateSettlementContract = appLazy(
  () =>
    import(
      'routes/pages/AuthorizedStack/Settlement/SettlementContracts/SettlementContract/Create'
    ),
);
const UpdateSettlementContract = appLazy(
  () =>
    import(
      'routes/pages/AuthorizedStack/Settlement/SettlementContracts/SettlementContract/Edit'
    ),
);
const AuditLogs = appLazy(() => import('routes/pages/AuthorizedStack/AuditLogs'));

export const SETTLEMENT_CHILDREN: IRoutesConfigItem[] = [
  {
    breadcrumb: 'settlementContracts.title',
    children: [
      {
        component: SettlementContracts,
        path: ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.PATH,
        permissions: [PERMISSIONS.CAN_VIEW_SETTLEMENT_CONTRACTS],
      },
      {
        breadcrumb: (params) => {
          const defaultTitle = 'settlementContract.title';
          if (!params?.id) {
            return defaultTitle;
          }
          return params.id;
        },
        children: [
          {
            component: SettlementContract,
            path: ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.SETTLEMENT_CONTRACT.PATH,
            permissions: [PERMISSIONS.CAN_VIEW_SETTLEMENT_CONTRACTS],
          },
          {
            breadcrumb: 'auditLogs.title',
            component: AuditLogs,
            path: ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.SETTLEMENT_CONTRACT.AUDIT_LOGS
              .PATH,
            permissions: [
              PERMISSIONS.CAN_VIEW_SETTLEMENT_CONTRACTS,
              PERMISSIONS.VIEW_AUDIT_LOGS,
            ],
            url: ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.SETTLEMENT_CONTRACT.AUDIT_LOGS
              .PATH,
          },
          {
            component: UpdateSettlementContract,
            path: ROUTES.SETTLEMENT.EDIT.PATH,
            permissions: [PERMISSIONS.CAN_UPDATE_SETTLEMENT_CONTRACT],
          },
        ],
        component: Outlet,
        path: ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.SETTLEMENT_CONTRACT.PATH,
        permissions: [PERMISSIONS.CAN_VIEW_SETTLEMENT_CONTRACTS],
        url: (params) => {
          const id = params?.id;
          const { PARAMS, PATH } =
            ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.SETTLEMENT_CONTRACT;
          return !id ? '' : generatePath(PATH, { [PARAMS.ID]: id });
        },
      },
      {
        breadcrumb: 'settlementContracts.form.title',
        component: CreateSettlementContract,
        path: ROUTES.SETTLEMENT.CREATE,
        permissions: [PERMISSIONS.CAN_CREATE_SETTLEMENT_CONTRACT],
        url: ROUTES.SETTLEMENT.CREATE,
      },
    ],
    component: Outlet,
    isPrivate: true,
    isSubFolder: true,
    navBarIcon: <ICONS_MAP.SettlementContracts />,
    path: ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.PATH,
    permissions: [PERMISSIONS.CAN_VIEW_SETTLEMENT_CONTRACTS],
    testId: 'navbarSettlementContracts',
    url: ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.PATH,
  },
];
